export const userRoleOptions = [
  { key: 1, text: "Pulsion", value: "pulsion" },
  { key: 2, text: "Admin", value: "admin" },
  { key: 3, text: "Doctor", value: "doctor" },
  { key: 4, text: "Receptionist", value: "receptionist" },
  { key: 5, text: "Patient", value: "patient" }
];
